import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogModule } from '@angular/material/dialog';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTable, MatTableDataSource, MatTableModule } from '@angular/material/table';
import { AccionesDialog } from '@models/base/identificadores.model';
import { SnackBarService } from '@services/snackBar/snack-bar-service.service';
import { DialogDeleteComponent } from 'src/app/component/dialog-delete/dialog-delete.component';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { isFalsy } from 'utility-types';
import { FormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BaseDto } from '@models/base/baseDto.model';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatNativeDateModule, MatRippleModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldControl, MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AppRolesDirective } from '@directives/appRoles/app-roles.directive';
import { ButtonCloseDialogComponent } from 'src/app/component/button-close-dialog/button-close-dialog.component';
import { ButtonCloseComponent } from 'src/app/component/button-close/button-close.component';
import { ButtonNewComponent } from 'src/app/component/button-new/button-new.component';
import { SinDatosParaMostrarComponent } from 'src/app/component/sin-datos-para-mostrar/sin-datos-para-mostrar.component';
import { ButtonFilterTableComponent } from 'src/app/component/button-filter-table/button-filter-table.component';
import { MatSelectModule } from '@angular/material/select';
import { AvatarInicialesComponent } from 'src/app/component/avatar-iniciales/avatar-iniciales.component';
import { ButtonFilterTableClearComponent } from 'src/app/component/button-filter-table-clear/button-filter-table-clear.component';
import { DialogParams } from 'src/app/interfaces/dialogParam.interface.model';
import { EstadoEscritoService } from '@services/estadoEscrito/estadoEscrito.service';
import { SelectUsuariosEmpresaComponent } from 'src/app/component/select-usuarios-empresa/select-usuarios-empresa.component';
import { DialogFormEscritoComponent } from '../dialog-form-escrito/dialog-form-escrito.component';
import { EscritoFilter } from '@models/escrito/escritoFilter.model';
import { EscritoDto } from '@models/escrito/escritoDto.model';
import { EscritoService } from '@services/escrito/escrito.service';
import { TipoEscritoService } from '@services/tipoEscrito/tipoEscrito.service';


@Component({
  standalone: true,
  imports: [SinDatosParaMostrarComponent, ButtonNewComponent, MatFormFieldModule, MatInputModule, ReactiveFormsModule, MatCardModule, MatIconModule, MatButtonModule,
    MatDividerModule, NgxSpinnerModule, MatTableModule,
    MatSliderModule, MatSlideToggleModule, MatMenuModule,
    MatDialogModule, MatDatepickerModule, MatExpansionModule,
    FormsModule, AppRolesDirective, MatSortModule, MatTooltipModule,
    MatPaginatorModule, MatRippleModule, CommonModule, ButtonFilterTableComponent, FormsModule, MatNativeDateModule, MatSelectModule, AvatarInicialesComponent, ButtonFilterTableClearComponent, SelectUsuariosEmpresaComponent],
  selector: 'app-list-escrito',
  templateUrl: './list-escrito.component.html',
  styleUrls: ['./list-escrito.component.css']
})
export class ListEscritoComponent {

  @Input() idExpediente!: number
  data = false
  esVistaTabla = true
  displayedColumns: string[] = [];
  dataSource = new MatTableDataSource<EscritoDto>();
  formBuilder = new FormBuilder
  formFilter: any;
  checkedFiltroAvanzado: boolean = false;
  lstEstados: BaseDto[] = [
    { id: 1, descripcion: 'Pendiente' },
    { id: 2, descripcion: 'En Proceso' },
    { id: 3, descripcion: 'Finalizado' },
  ];
  lstPrioridades: BaseDto[] = [
    { id: 1, descripcion: 'Baja' },
    { id: 2, descripcion: 'Media' },
    { id: 3, descripcion: 'Alta' },
  ];

  lstNiveles: BaseDto[] = [
    { id: 0, descripcion: 'Todos' },
    { id: 1, descripcion: 'Baja' },
    { id: 2, descripcion: 'Media' },
    { id: 3, descripcion: 'Alta' },
  ];
  escritoFilter!: EscritoFilter;
  escritos!: EscritoDto[];
  filtro: EscritoFilter = new EscritoFilter;
  filtroEscritosGuardado!: string | null;

  @ViewChild(MatTable, { static: true }) table!: MatTable<any>;
  private paginator!: MatPaginator;
  private sort!: MatSort;
  estadosEscrito!: BaseDto[];
  tiposEscrito!: BaseDto[];
  accionesDialog = AccionesDialog;
  listadoEscritos!: EscritoDto[];
  @Output() listadoEscritosEmitter = new EventEmitter<EscritoDto[]>();
  isMinimized!: boolean;

  @ViewChild(MatSort) set matSort(ms: MatSort) {
    this.sort = ms;
  }

  @ViewChild(MatPaginator) set matPaginator(mp: MatPaginator) {
    this.paginator = mp;
  }
  constructor(
    private escritoService: EscritoService,
    private snackBar: SnackBarService,
    private tipoEscritoService: TipoEscritoService,
    private estadoEscritoService: EstadoEscritoService,
    private spinner: NgxSpinnerService,
    private breakpointObserver: BreakpointObserver,
    private dialog: MatDialog
  ) {

    this.formFilter = this.formBuilder.group({
      Id: [''],
      Titulo: [''],
      Descripcion: [''],
      FechaModificacionDesde: [null],
      FechaModificacionHasta: [null],
      FechaAltaDesde: [null],
      FechaAltaHasta: [null],
      IdsEstadoEscrito: [null],
      IdsTipoEscrito: [null],
      CreadoPor: [null],
      ModificadoPor: [null],
      CuerpoHTML: [null],
      IdExpediente: [null],
      FechaCreacionDesde: [null],
      FechaCreacionHasta: [null]
    });

  }



  ngOnInit(): void {
    this.getAllTiposEscrito()
    this.getAllEstadosEscrito()

    if (this.idExpediente) {
      this.aplicarFiltro()
      this.breakpointObserver.observe(['(max-width: 600px)']).subscribe(result => {
        this.displayedColumns = result.matches ?
          ["titulo", "accion"] :
          ["titulo", "tipoEscrito", "fechaCreacion", "estadoEscrito", "creadoPor", "accion"];
      });
    }
    else {
      this.breakpointObserver.observe(['(max-width: 600px)']).subscribe(result => {
        this.displayedColumns = result.matches ?
          ["titulo", "accion"] :
          ["titulo", "tipoEscrito", "fechaCreacion", "estadoEscrito", "creadoPor", "accion"];
      });
    }

    this.dataSource.paginator = this.paginator;

    this.dataSource.filterPredicate = (data: EscritoDto, filter: string) => {
      return data.titulo.toLowerCase().includes(filter.trim().toLowerCase());
    };

    if (this.idExpediente) {
      this.formFilter.controls['IdExpediente'].setValue(this.idExpediente);
      this.guardarFiltro()
      this.aplicarFiltro()
    }

    this.filtroEscritosGuardado = localStorage.getItem('filtroEscritosGuardado');
    if (this.filtroEscritosGuardado) {
      this.filtro = JSON.parse(this.filtroEscritosGuardado);
      this.formFilter.patchValue(this.filtro);
    }
  }

  guardarFiltro() {
    this.filtro = this.formFilter.value;
    localStorage.setItem('filtroEscritosGuardado', JSON.stringify(this.filtro));
  }

  onCreadoPorSeleccionado(usuario: any) {
    this.formFilter.get('CreadoPor')?.setValue(usuario.id);
  }

  onAprobadoPorSeleccionado(usuario: any) {
    this.formFilter.get('ModificadoPor')?.setValue(usuario.id);
  }


  limpiarFiltro() {
    this.formFilter.reset();
    localStorage.removeItem('filtroEscritosGuardado');
  }

  aplicarFiltro(filtro: EscritoFilter = this.formFilter.value) {
    this.limpiarFiltro()
    this.getAllEscritoFilter(this.filtro)
    this.guardarFiltro();
  }

  esHoy(fecha: string | Date): boolean {
    const hoy = new Date();
    const fechaFin = new Date(fecha);
    var esHoy = (
      hoy.getDate() === fechaFin.getDate() &&
      hoy.getMonth() === fechaFin.getMonth() &&
      hoy.getFullYear() === fechaFin.getFullYear()
    )
    return esHoy;
  }


  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;

    this.dataSource.filterPredicate = (data: EscritoDto, filter: string) => {
      return data.titulo.toLowerCase().includes(filter.trim().toLowerCase());
    };
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }




  filtrosAvanzados(event: any) {
    if (event.checked == true)
      this.checkedFiltroAvanzado = true
    else
      this.checkedFiltroAvanzado = false
  }
  cambiarVista(event: any) {
    if (event.checked == true)
      this.esVistaTabla = true
    else
      this.esVistaTabla = false
  }


  getAllTiposEscrito() {
    this.spinner.show("spTipoEscrito")
    this.tipoEscritoService.getAll()
      .subscribe(
        data => {
          this.spinner.hide("spTipoEscrito")
          this.tiposEscrito = data
        },
        error => {
          this.spinner.hide("spTipoEscrito")
          this.snackBar.showError(error, "Error");
        })
  }

  getAllEstadosEscrito() {
    this.spinner.show('spEstadosEscrito')
    this.estadoEscritoService.getAll()
      .subscribe(
        data => {
          this.spinner.hide('spEstadosEscrito')
          this.estadosEscrito = data
        },
        error => {
          this.spinner.hide('spEstadosEscrito')
          this.snackBar.showError(error, "Error");
        })
  }

  getAllEscritoFilter(escritoFilter: EscritoFilter) {
    this.spinner.show('spListado')
    this.escritoService.getAllByFilter(escritoFilter)
      .subscribe(
        data => {
          this.spinner.hide('spListado')
          this.dataSource.data = data
          this.listadoEscritos = data
          this.data = this.dataSource.data.length >= 1 ? true : false
        },
        error => {
          this.spinner.hide('spListado')
          this.snackBar.showError(error, "Error");
        })
  }

  openDialog<T>(params: DialogParams<T>) {
    const { accion, entidad } = params;

    const data = {
      ...entidad,
      accion,
      idExpediente: this.idExpediente
    };

    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = false
    dialogConfig.disableClose = true,
    dialogConfig.width = "70%"
    dialogConfig.data = data

    const dialogRef = this.dialog.open(DialogFormEscritoComponent, dialogConfig);

    dialogRef.componentInstance.toggleMinimizar = () => {
      this.isMinimized = !this.isMinimized;
      const overlayPane = document.querySelector('.cdk-overlay-pane');
      if (overlayPane) {
        overlayPane.classList.toggle('minimizado-container', this.isMinimized);
      }
    };
    dialogRef.afterClosed().subscribe(result => {
      if (!result || !result.event) return;

      switch (result.event) {
        case AccionesDialog.Agregar:
          this.aplicarFiltro()
          break;
        case AccionesDialog.Modificar:
          this.aplicarFiltro()
          break;
        case AccionesDialog.Eliminar:
          this.aplicarFiltro()
          break;
        default:

          break;
      }

    });
  }
  isFalsy(valor: any) {
    return isFalsy(valor)
  }

  trackByItems(index: number, item: any): any { return item; }
}
